import {Row} from './useRows'

/** Returns the number of hidden rows before the provided `rowIndex`. */
export const getHiddenRowsBefore = (rowIndex: number, rows: Row[]) => {
    return rows.slice(0, rowIndex).filter((row) => row.style.fadedOut).length
}
